// src/router/organograma.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['admin']

const organogramaBreadCrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'Organograma',
    to: 'OrganogramaTimes'
  }
]

export default [
  {
    path: '/organograma/times',
    name: 'OrganogramaTimes',
    component: () => import('@/views/Organograma/Times/TimesListPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Hierarquia de Times',
      breadcrumb: [...organogramaBreadCrumb, { label: 'Times', to: 'OrganogramaTimes' }]
    }
  },
  {
    path: '/organograma/funcoes',
    name: 'OrganogramaFuncoes',
    component: () => import('@/views/Organograma/Funcoes/FuncoesListPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Hierarquia de Funções',
      breadcrumb: [...organogramaBreadCrumb, { label: 'Funções', to: 'OrganogramaFuncoes' }]
    }
  }
]
